import { z } from "zod";
// 30-min granularity for the pilot — a product simplification (the slot
// engine handles any minute), relaxable later without a migration.
const minuteOfDaySchema = z.number().int().min(0).max(1440).multipleOf(30);
export const availabilityRangeSchema = z
    .object({
    // 0 = Sunday, matching JS Date#getDay and the slot engine.
    weekday: z.number().int().min(0).max(6),
    startMinute: minuteOfDaySchema,
    endMinute: minuteOfDaySchema,
})
    .refine((r) => r.startMinute < r.endMinute, {
    message: "startMinute must be before endMinute",
});
export const replaceAvailabilitySchema = z.object({
    // 6 ranges per weekday is already generous; 42 caps the payload.
    ranges: z.array(availabilityRangeSchema).max(42),
});
const dateStrSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");
export const createVisitBlackoutSchema = z
    .object({
    /** null = whole school */
    userId: z.string().uuid().nullable().default(null),
    dateFrom: dateStrSchema,
    dateTo: dateStrSchema,
    /** Both null = full day; both set = partial day. */
    startMinute: minuteOfDaySchema.nullable().default(null),
    endMinute: minuteOfDaySchema.nullable().default(null),
    reason: z.string().trim().min(1).max(255).optional(),
})
    .superRefine((b, ctx) => {
    // ISO date strings compare correctly as strings.
    if (b.dateFrom > b.dateTo) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "dateFrom must be on or before dateTo",
            path: ["dateTo"],
        });
    }
    const hasStart = b.startMinute !== null;
    const hasEnd = b.endMinute !== null;
    if (hasStart !== hasEnd) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "startMinute and endMinute must both be set or both be null",
            path: ["endMinute"],
        });
    }
    if (hasStart && hasEnd && b.startMinute >= b.endMinute) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "startMinute must be before endMinute",
            path: ["endMinute"],
        });
    }
});
export const rescheduleVisitBodySchema = z.object({
    startsAt: z.string().datetime(),
});
export const cancelVisitBodySchema = z.object({
    reason: z.string().trim().min(1).max(255).optional(),
});
export const visitAttendanceBodySchema = z.object({
    status: z.enum(["attended", "no_show"]),
});
//# sourceMappingURL=visits.js.map